import { MapPin } from "lucide-react";
import EmptyAddress from "./EmptyAddress";

export default function AddressSection({ addresses, setShowAddressForm }) {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center mb-4">
        <MapPin className="h-5 w-5 text-gray-500 mr-2" />
        <h2 className="text-lg font-semibold text-gray-900">
          Endereço de Entrega
        </h2>
      </div>

      {addresses.length === 0 ? (
        <EmptyAddress setShowAddressForm={setShowAddressForm} />
      ) : (
        addresses.map((address) => (
          <div key={address.id} className="mb-4">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center">
                <input
                  type="radio"
                  id={address.id}
                  name="endereco"
                  className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                  defaultChecked={address.principal}
                />
                <label
                  htmlFor={address.id}
                  className="ml-2 block text-sm font-medium text-gray-700">
                  {address.tipo}
                </label>
              </div>
              <button className="text-sm text-green-600 hover:text-green-800">
                Editar
              </button>
            </div>
            <div className="ml-6 text-sm text-gray-600">
              <p>{address.nome}</p>
              <p>{address.rua}</p>
              <p>
                {address.bairro} - {address.cidade}, {address.estado}
              </p>
              <p>CEP: {address.cep}</p>
              <p>Telefone: {address.telefone}</p>
            </div>
          </div>
        ))
      )}

      <button
        onClick={() => setShowAddressForm(true)}
        className="flex items-center text-green-600 hover:text-green-800 text-sm font-medium">
        + Adicionar novo endereço
      </button>
    </div>
  );
}
